import script from "./OfflineBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfflineBanner.vue?vue&type=script&setup=true&lang=ts"

import "./OfflineBanner.vue?vue&type=style&index=0&id=6fe2bc2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe2bc2a"]])

export default __exports__